module.exports = __webpack_public_path__ + "media/img/vca/prizes/motionartspace-80a3c71212a6e361ef70ebc5fdf7563b.png";